export const baseUrl = '/wp-json/dkwp/v2';
export const baseUrlV3 = '/wp-json/dkwp/v3';

export const API_RESOURCE_OFFERS = `${baseUrl}/offers`;
export const API_RESOURCE_DRIVESPARK_OFFERS = `${baseUrlV3}/offers`;
export const API_RESOURCE_SEARCH = `${baseUrl}/search`;

export const URL_STOCK = '/wp-json/dkwp/v3/car/stocks';
